



















import Vue from 'vue'
import { ImageQRElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ImageQREl',

  data: () => ({
    imgError: false
  }),

  props: {
    templateItemData: {
      type: Object as () => ImageQRElInterface,
      required: true
    }
  },

  computed: {
    buttonStyle (): Record<string, string> {
      if (this.templateItemData.button) {
        return {
          color: this.templateItemData.button.textColor,
          backgroundColor: this.templateItemData.button.buttonColor
        }
      } else {
        return {}
      }
    }
  }
})
